module.exports = __webpack_public_path__ + "static/media/orange-timer.c438de75.png";